<template>
  <ul class="w-full flex justify-center items-center">
    <li class="justify-center items-center w-full">
      <a :href="`https://discord.com/oauth2/authorize?client_id=1235517752240771122&response_type=code&redirect_uri=${authUrl}%2Fdiscord&scope=identify+email`"
         class="py-2 rounded-md w-full border border-white flex gap-2 justify-center items-center text-white">
        <Icon icon="bxl:discord-alt" height="24"/>
        Continue with Discord</a>
    </li>
    <!--    <li class="flex-1">
          <a
              href="#"
              class="inline-flex h-10 w-10 bg-[#395599] text-white text-2xl flex-col items-center justify-center rounded-full"
          >
            <img src="@/assets/images/icon/fb.svg" alt=""/>
          </a>
        </li>
        <li class="flex-1">
          <a
              href="#"
              class="inline-flex h-10 w-10 bg-[#0A63BC] text-white text-2xl flex-col items-center justify-center rounded-full"
          >
            <img src="@/assets/images/icon/in.svg" alt=""/>
          </a>
        </li>
        <li class="flex-1">
          <a
              href="#"
              class="inline-flex h-10 w-10 bg-[#EA4335] text-white text-2xl flex-col items-center justify-center rounded-full"
          >
            <img src="@/assets/images/icon/gp.svg" alt=""/>
          </a>
        </li>-->
  </ul>
</template>
<script setup>
import Icon from "@/components/Icon/index.vue";

const authUrl = import.meta.env.VITE_AUTH_URL;
</script>
<style lang=""></style>
